const registryItems = [
  {
    id: 'item-1',
    name: 'KitchenAid Stand Mixer',
    price: 449,
    url: 'https://www.kitchenaid.com/countertop-appliances/stand-mixers/tilt-head-stand-mixers/p.deluxe-4-5-quart-tilt-head-stand-mixer.KSM97PT.html?region_id=LDC822&productcategory=stand_mixers&frt=35&utm_source=ga&utm_medium=ps&utm_campaign=dts_dtc_evg_sda&utm_content=kad:dts_dtc_evg_sda:ga:ps:na:na:cpc:thstm:na:na:pmax:na&gclsrc=aw.ds&gad_source=1&gad_campaignid=23374652573&gclid=EAIaIQobChMIo8afgYOtlAMVG0X_AR3SBxBTEAYYBiABEgI1APD_BwE',
    image: '',
    description: 'Classic 5-quart stand mixer in Pistachio, somtimes its on sale for 300',
  },
  {
    id: 'item-2',
    name: 'Low Bowls',
    price: 42,
    url: 'https://sweese.com/products/pasta-bowls-hot-assorted?variant=39561983656024',
    image: '',
    description: 'Low pasta bowls for eating'
  },
  {
    id: 'item-3',
    name: 'Bissell CleanView Bagless Vacuum',
    price: 169,
    url: 'https://www.amazon.com/dp/B07F6MXJ9X?tag=goodhousekeeping_auto-append-20&th=1',
    image: '',
    description: 'Vacuum for cleaning, ours is mostly broken sadly'
  },
    {
    id: 'item-4',
    name: 'Ground bikerack',
    price: 77,
    url: 'https://www.wayfair.com/ClosetMaid--ProGarage-Freestanding-Bike-Rack-DUJM1395-L3255-K~DUJM1395.html?refid=FR49-DUJM1395',
    image: '',
    description: 'Bikerack for garage and storage, does not have to be this exact one, but minimum space for three bikes'
  },
  {
    id: 'item-5',
    name: 'Mini Spatulas',
    price: 10,
    url: 'https://www.cuisinart.com/mini-spatulas-set-of-3/CTG-00-S3MS.html',
    image: '',
    description: 'Mini Spatulas for scraping out the extra waffle batter. Does not have to be these specific ones.'
  },
  {
    id: 'item-6',
    name: 'Oil Pourer and Mister',
    price: 11,
    url: 'https://www.cuisinart.com/2-in-1-oil-mister-and-pourer/CTG-00-MIS.html',
    image: '',
    description: 'Another kitchen gizmo'
  },
  {
    id: 'item-7',
    name: 'Kitchen Shears',
    price: 8,
    url: 'https://www.cuisinart.com/8-all-purpose-shears/C77-SHR8B.html',
    image: '',
    description: 'All purpose kitchen shears'
  },
];

export default registryItems;
